import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
 
/* This is a component which we pass in modal*/

@Component({
  selector: 'modal-content',
  templateUrl: './modal.component.html'
})

export class ModalContentComponent implements OnInit {
  paramList: any = {
    displayMessage : '',
    showFootNote : false,
    footNote : ''
  };
  public event: EventEmitter<any> = new EventEmitter();

  constructor(public modalRef: BsModalRef) {}

  ngOnInit() {
  }

  confirm(): void {
    this.triggerEvent(true);
    this.modalRef.hide();
  }
 
  decline(): void {
    this.triggerEvent(false);
    this.modalRef.hide();
  }

  triggerEvent(res: boolean) {
    this.event.emit({ data: res });
  }
}